import { uniq, difference, uniqBy } from 'lodash';
import * as C from '../constants';
import * as ActionCreators from '../actions/ActionCreators';
import { actionEqual } from './utils';

const defaultState: FavouriteState = {
  data_item_ids: [],
  shop_item_ids: [],
  state: C.STATE.FAVOURITE.DEFAULT,
  dataItemTotal: 0,
  shopItemTotal: 0,
  selectedMarketReportItem: null,
  selectedDataItem: null,
  compareDataItems: [],
  comparePriceFilters: {
    frequency: C.TRADES.DAILY,
    currency: C.TRADES.Currency.USD,
  },
  referenceYear: 0,
  referencePrice: {},
  referenceProductId: null,
  shopItems: [],
  dataItems: [],
  tradeFormDataItem: null,
};
export const MAX_COMPARE_PRICE_ITEMS = 10;
export const getFavouriteDataItemIds = (state: FavouriteState) =>
  state.data_item_ids;

export const getFavouriteShopItemIds = (state: FavouriteState) =>
  state.shop_item_ids;

export default function favourite(
  state: FavouriteState = defaultState,
  action: Action
): FavouriteState {
  if (actionEqual(action, ActionCreators.actionAddItemToFavourite)) {
    const p = action.payload;
    const add = (ids, items) => {
      if (items) {
        return uniq(ids.concat(items.map(x => x.id)));
      } else {
        return ids;
      }
    };
    return {
      ...state,
      data_item_ids: add(state.data_item_ids, p.data_items),
      shop_item_ids: add(state.shop_item_ids, p.shop_items),
    };
  } else if (actionEqual(action, ActionCreators.actionRemoveFromFavourite)) {
    const { data_item_ids, shop_item_ids } = action.payload;
    return {
      ...state,
      data_item_ids: difference(state.data_item_ids, data_item_ids),
      shop_item_ids: difference(state.shop_item_ids, shop_item_ids),
      dataItems: state.dataItems.filter(
        item => !data_item_ids.includes(item.id)
      ),
      shopItems: state.shopItems.filter(
        item => !shop_item_ids.includes(item.id)
      ),
      dataItemTotal: state.dataItemTotal - data_item_ids.length,
      shopItemTotal: state.shopItemTotal - shop_item_ids.length,
    };
  } else if (actionEqual(action, ActionCreators.actionUpdateState)) {
    return {
      ...state,
      state: action.payload.state || C.STATE.FAVOURITE.SERVER_ERROR,
    };
  } else if (actionEqual(action, ActionCreators.actionToggleEditSettings)) {
    return {
      ...state,
      isEditSettings: !state.isEditSettings,
    };
  } else if (actionEqual(action, ActionCreators.actionSetKeyword)) {
    return {
      ...state,
      searchKey: action.payload.searchKey,
    };
  } else if (
    actionEqual(action, ActionCreators.actionUpdateFavouriteDataItemTotal)
  ) {
    return {
      ...state,
      dataItemTotal: action.payload.total,
    };
  } else if (
    actionEqual(action, ActionCreators.actionUpdateFavouriteShopItemTotal)
  ) {
    return {
      ...state,
      shopItemTotal: action.payload.total,
    };
  } else if (actionEqual(action, ActionCreators.actionOpenMarketReportInfo)) {
    return {
      ...state,
      selectedMarketReportItem: action.payload.item,
    };
  } else if (actionEqual(action, ActionCreators.actionOpenDataItemInfo)) {
    return {
      ...state,
      selectedDataItem: action.payload.item,
    };
  } else if (actionEqual(action, ActionCreators.actionAddFavouriteDataItem)) {
    return {
      ...state,
      dataItems: uniqBy([...state.dataItems, ...action.payload.items], 'id'),
    };
  } else if (actionEqual(action, ActionCreators.clearFavouriteDataItems)) {
    return {
      ...state,
      dataItems: [],
    };
  } else if (
    actionEqual(action, ActionCreators.actionClearFavouriteShopItems)
  ) {
    return {
      ...state,
      shopItems: [],
    };
  } else if (actionEqual(action, ActionCreators.actionAddFavouriteShopItem)) {
    return {
      ...state,
      shopItems: uniqBy([...state.shopItems, ...action.payload.items], 'id'),
    };
  } else if (actionEqual(action, ActionCreators.addDataItemsToComparePrice)) {
    if (state.compareDataItems.length === MAX_COMPARE_PRICE_ITEMS) {
      return state;
    }
    const { items, overwrite } = action.payload;
    const compareDataItems = !!overwrite
      ? items
      : [...state.compareDataItems, ...items];
    return {
      ...state,
      compareDataItems: uniqBy(compareDataItems, 'id'),
    };
  } else if (actionEqual(action, ActionCreators.removeDataItemToComparePrice)) {
    return {
      ...state,
      compareDataItems: state.compareDataItems.filter(
        item => item.id !== action.payload.id
      ),
    };
  } else if (actionEqual(action, ActionCreators.updateComparePriceFilters)) {
    return {
      ...state,
      comparePriceFilters: {
        ...state.comparePriceFilters,
        ...action.payload.fitlers,
      },
    };
  } else if (actionEqual(action, ActionCreators.actionOpenTradeFromDrawer)) {
    return {
      ...state,
      tradeFormDataItem: action.payload.item,
    };
  } else if (actionEqual(action, ActionCreators.updateReferenceYear)) {
    return {
      ...state,
      referenceYear: action.payload.year,
      referenceProductId:
        state.referenceProductId != null
          ? state.referenceProductId
          : state.compareDataItems[0].id,
    };
  } else if (actionEqual(action, ActionCreators.updateReferencePrice)) {
    return {
      ...state,
      referencePrice: action.payload.price,
    };
  } else if (actionEqual(action, ActionCreators.updateReferenceProduct)) {
    return {
      ...state,
      referenceProductId: action.payload.id,
    };
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/favourite.ts